import { adminRole, adminNotice, buyerInquiry, contractPlan, ipListing, ipSaleApplication, officeConsultation, officeCustomer, ProcessAudit, qna, quoteSend } from './types';

export const activeAdmin: { name: string; email: string; role: adminRole } = {
    name: '웅빈',
    email: 'admin@example.com',
    role: 'super_admin'
};

export function formatDateTime(date: Date = new Date()): string {
    const pad = (value: number) => String(value).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function makeAudit(memo: string = ''): ProcessAudit {
    return {
        handler: activeAdmin.name,
        handledAt: formatDateTime(),
        memo
    };
}

let sequence = 900;
export function nextId(prefix: string): string {
    sequence += 1;
    return `${prefix}-${sequence}`;
}

export const contractPlans: contractPlan[] = [
    { id: 'plan-a', name: 'A타입(2명이내)', maxUsers: 2, description: '소형 변리사무소 기본 계약', monthlyFee: 220000 },
    { id: 'plan-b', name: 'B타입(5명이내)', maxUsers: 5, description: '중형 사무소 협업형 계약', monthlyFee: 440000 },
    { id: 'plan-c', name: 'C타입(10명이내)', maxUsers: 10, description: '대형 사무소 전담 운영 계약', monthlyFee: 770000 }
];

export const officeCustomers: officeCustomer[] = [
    {
        id: 'office-001',
        customerName: '한빛국제특허법률사무소',
        patentAttorney: '정민수 변리사',
        contractDate: '2025-11-01',
        contractEndDate: '2026-10-31',
        contractType: 'B타입(5명이내)',
        contractPlanId: 'plan-b',
        userCount: 4,
        managerName: '오세린',
        contact: '02-584-2101',
        email: 'serin.oh@hanbit-ip.co.kr',
        officeAddress: '서울시 강남구 테헤란로 152',
        assignee: '이준호',
        status: '정상',
        lastContactAt: '2026-06-28 15:10'
    },
    {
        id: 'office-002',
        customerName: '우림특허사무소',
        patentAttorney: '박도현 변리사',
        contractDate: '2025-07-15',
        contractEndDate: '2026-07-14',
        contractType: 'A타입(2명이내)',
        contractPlanId: 'plan-a',
        userCount: 2,
        managerName: '한유진',
        contact: '031-781-3302',
        email: 'yjhan@woorimpat.com',
        officeAddress: '경기도 성남시 분당구 판교역로 235',
        assignee: '김보미',
        status: '만료예정',
        lastContactAt: '2026-06-29 09:40'
    },
    {
        id: 'office-003',
        customerName: '세움IP파트너스',
        patentAttorney: '강혜원 변리사',
        contractDate: '2026-01-10',
        contractEndDate: '2027-01-09',
        contractType: 'C타입(10명이내)',
        contractPlanId: 'plan-c',
        userCount: 8,
        managerName: '문태식',
        contact: '02-742-9195',
        email: 'tsmoon@seumip.com',
        officeAddress: '서울시 종로구 종로 72',
        assignee: '최서윤',
        status: '정상',
        lastContactAt: '2026-06-27 11:25'
    },
    {
        id: 'office-004',
        customerName: '리앤권 특허법인',
        patentAttorney: '권나영 변리사',
        contractDate: '2025-08-01',
        contractEndDate: '2026-07-31',
        contractType: 'B타입(5명이내)',
        contractPlanId: 'plan-b',
        userCount: 5,
        managerName: '이상혁',
        contact: '051-808-8821',
        email: 'shlee@leekwonip.co.kr',
        officeAddress: '부산시 해운대구 센텀중앙로 48',
        assignee: '김보미',
        status: '만료예정',
        lastContactAt: '2026-06-26 14:05'
    }
];

export const adminNotices: adminNotice[] = [
    { id: 'notice-101', officeId: 'office-002', title: '계약 갱신 안내', body: '7월 만료 예정 계약 갱신 절차 안내', status: '발송완료', sender: '김보미', sentAt: '2026-06-29 10:12', audit: { handler: '김보미', handledAt: '2026-06-29 10:12', memo: '만료 D-15 안내' } },
    { id: 'notice-102', officeId: 'office-003', title: '신규 기능 안내', body: '연차료 일정 관리 기능 개선 사항 안내', status: '발송완료', sender: '최서윤', sentAt: '2026-06-28 16:20', audit: { handler: '최서윤', handledAt: '2026-06-28 16:20' } },
    { id: 'notice-103', officeId: 'office-004', title: '사용 인원 확인 요청', body: 'B타입 최대 인원 도달에 따른 계약 변경 검토', status: '발송대기', sender: '김보미', sentAt: '2026-06-30 17:00', audit: { handler: '김보미', handledAt: '2026-06-30 09:30', memo: '예약 발송' } }
];

export const quoteSends: quoteSend[] = [
    { id: 'quote-201', officeId: 'office-002', title: 'A타입 갱신 견적서', amount: 2640000, fileName: 'woongbin_quote_A_202607.pdf', status: '발송완료', sender: '김보미', sentAt: '2026-06-29 10:15', audit: { handler: '김보미', handledAt: '2026-06-29 10:15' } },
    { id: 'quote-202', officeId: 'office-004', title: 'B타입 갱신 및 C타입 전환 견적', amount: 5280000, fileName: 'woongbin_quote_BC_202607.pdf', status: '발송대기', sender: '김보미', sentAt: '2026-06-30 17:10', audit: { handler: '김보미', handledAt: '2026-06-30 09:42', memo: '예약 발송' } }
];

export const ipSaleApplications: ipSaleApplication[] = [
    {
        id: 'sale-301',
        sellerName: '윤재호',
        sellerCompany: '넥스트바이오랩',
        sellerContact: '010-2310-7741',
        sellerEmail: 'jh.yoon@nextbio.kr',
        rightType: '특허',
        applicationNumber: '10-2021-0148123',
        applicationDate: '2021-11-04',
        registrationNumber: '10-2449128',
        registrationDate: '2022-09-29',
        owner: '넥스트바이오랩 주식회사',
        summary: '마이크로바이옴 기반 피부 진단 키트 제조 방법',
        desiredPrice: 85000000,
        attachments: { rightsDocument: true, otherDocument: true },
        status: '검수대기',
        submittedAt: '2026-06-30 08:50',
        reviewer: '김보미',
        reviewMemo: ''
    },
    {
        id: 'sale-302',
        sellerName: '조은서',
        sellerCompany: '개인',
        sellerContact: '010-8840-1182',
        sellerEmail: 'eunseo.cho@gmail.com',
        rightType: '상표',
        applicationNumber: '40-2022-0091182',
        applicationDate: '2022-05-18',
        registrationNumber: '40-1938810',
        registrationDate: '2023-02-14',
        owner: '조은서',
        summary: '프리미엄 반려식품 브랜드 상표권',
        desiredPrice: 18000000,
        attachments: { rightsDocument: true, otherDocument: false },
        status: '보완요청',
        submittedAt: '2026-06-29 13:34',
        reviewer: '이준호',
        reviewedAt: '2026-06-29 16:10',
        reviewMemo: '기타서류 첨부 요청',
        audit: { handler: '이준호', handledAt: '2026-06-29 16:10', memo: '기타서류 누락' }
    },
    {
        id: 'sale-303',
        sellerName: '김태완',
        sellerCompany: '알파로보틱스',
        sellerContact: '010-4922-6098',
        sellerEmail: 'twkim@alpharobotics.io',
        rightType: '디자인',
        applicationNumber: '30-2020-0059012',
        applicationDate: '2020-10-15',
        registrationNumber: '30-1134552',
        registrationDate: '2021-06-22',
        owner: '알파로보틱스',
        summary: '물류 피킹 로봇 외관 디자인',
        desiredPrice: 32000000,
        attachments: { rightsDocument: true, otherDocument: true },
        status: '검수대기',
        submittedAt: '2026-06-29 09:05',
        reviewer: '최서윤',
        reviewMemo: ''
    }
];

export const ipListings: ipListing[] = [
    {
        id: 'listing-401',
        title: '저전력 엣지 AI 추론 장치 특허',
        rightType: '특허',
        applicationNumber: '10-2020-0119344',
        applicationDate: '2020-09-15',
        registrationNumber: '10-2388120',
        registrationDate: '2022-04-20',
        owner: '에이엠시스템즈',
        summary: '산업용 카메라의 실시간 불량 판정에 쓰이는 저전력 AI 추론 회로',
        askingPrice: 120000000,
        status: '공개중',
        sellerName: '박성우',
        sellerContact: '010-3109-7732',
        sellerEmail: 'swpark@amsys.co.kr',
        publicSellerLabel: '법인 판매자',
        internalMemo: '관심 제조사 2곳. NDA 필요.',
        updatedBy: '김보미',
        updatedAt: '2026-06-28 18:30',
        audit: { handler: '김보미', handledAt: '2026-06-28 18:30', memo: '대표 이미지 교체' }
    },
    {
        id: 'listing-402',
        title: '친환경 포장재 조성물 등록특허',
        rightType: '특허',
        applicationNumber: '10-2019-0039841',
        applicationDate: '2019-04-03',
        registrationNumber: '10-2210457',
        registrationDate: '2021-02-05',
        owner: '그린패키징',
        summary: '생분해 필름 강도 개선 조성물 및 제조 공정',
        askingPrice: 76000000,
        status: '거래진행',
        sellerName: '임소희',
        sellerContact: '010-5510-2300',
        sellerEmail: 'sohee.lim@greenpkg.kr',
        publicSellerLabel: '기업 판매자',
        internalMemo: '오션푸드와 가격 협의 중.',
        updatedBy: '이준호',
        updatedAt: '2026-06-30 09:10',
        audit: { handler: '이준호', handledAt: '2026-06-30 09:10', memo: '상담중 상태 반영' }
    },
    {
        id: 'listing-403',
        title: '헬스케어 앱 UI 디자인권',
        rightType: '디자인',
        applicationNumber: '30-2021-0021441',
        applicationDate: '2021-05-12',
        registrationNumber: '30-1192208',
        registrationDate: '2022-01-18',
        owner: '메디픽셀',
        summary: '의료 예약 및 문진 플로우 화면 디자인',
        askingPrice: 24000000,
        status: '비공개',
        sellerName: '정유라',
        sellerContact: '010-6227-8330',
        sellerEmail: 'yrjung@medipixel.kr',
        publicSellerLabel: '비공개 판매자',
        internalMemo: '권리 범위 확인 후 재공개 예정.',
        updatedBy: '최서윤',
        updatedAt: '2026-06-27 15:35',
        audit: { handler: '최서윤', handledAt: '2026-06-27 15:35', memo: '권리 범위 확인' }
    }
];

export const buyerInquiries: buyerInquiry[] = [
    { id: 'buyer-501', buyerName: '남지훈', companyName: '오션푸드', contact: '010-4882-9021', email: 'jh.nam@oceanfood.kr', listingId: 'listing-402', interestedRight: '친환경 포장재 조성물 등록특허', content: '식품 포장 라인에 적용 가능한지 기술 미팅을 요청합니다.', budget: 65000000, status: '상담중', memo: '7/1 14:00 기술 검토 미팅 예정', createdAt: '2026-06-30 09:20', assignee: '이준호', audit: { handler: '이준호', handledAt: '2026-06-30 09:45', memo: '상담 배정' } },
    { id: 'buyer-502', buyerName: '송하린', companyName: '브라이트모빌리티', contact: '010-9220-1183', email: 'harin.song@brightmobi.io', listingId: 'listing-401', interestedRight: '저전력 엣지 AI 추론 장치 특허', content: '카메라 모듈 제조사와 공동 매입을 검토 중입니다.', budget: 100000000, status: '접수', memo: '', createdAt: '2026-06-30 11:05', assignee: '김보미' },
    { id: 'buyer-503', buyerName: '백준영', companyName: '아이케어랩', contact: '010-7720-6654', email: 'jy.baek@eyecarelab.co.kr', listingId: 'listing-403', interestedRight: '헬스케어 앱 UI 디자인권', content: '매물 비공개 사유와 양도 가능 일정을 알고 싶습니다.', budget: 18000000, status: '보류', memo: '판매자 권리 범위 확인 대기', createdAt: '2026-06-29 17:42', assignee: '최서윤', audit: { handler: '최서윤', handledAt: '2026-06-29 18:05', memo: '권리 범위 확인 대기' } }
];

export const qnas: qna[] = [
    { id: 'qna-601', system: 'ip_management', userType: 'office', sourceName: '우림특허사무소', relatedId: 'office-002', title: '계약 갱신 견적서 재발송 요청', content: '담당 변리사 이메일로 견적서를 다시 받을 수 있을까요?', status: '접수', answer: '', createdAt: '2026-06-30 09:12', assignee: '김보미' },
    { id: 'qna-602', system: 'ip_management', userType: 'office', sourceName: '세움IP파트너스', relatedId: 'office-003', title: '사용 인원 추가 문의', content: '임시 사용자 2명을 1개월만 추가할 수 있는지 문의드립니다.', status: '답변완료', answer: 'C타입 내 잔여 좌석 2명으로 즉시 추가 가능합니다.', createdAt: '2026-06-29 15:40', answeredAt: '2026-06-29 16:05', assignee: '최서윤', audit: { handler: '최서윤', handledAt: '2026-06-29 16:05' } },
    {
        id: 'qna-603',
        system: 'ip_market',
        userType: 'buyer',
        sourceName: '이도윤',
        companyName: '마이크로젠랩',
        contact: '010-5728-1406',
        email: 'doyoon.lee@microgenlab.co.kr',
        title: '바이오 진단 특허 구매 상담',
        content: '마이크로바이옴 기반 질환 진단 기술의 권리 범위와 양도 가능 조건을 상담받고 싶습니다.',
        status: '접수',
        answer: '',
        createdAt: '2026-06-30 10:05',
        assignee: '김보미',
        consultationChannel: '자유상담',
        consultationKind: '구매희망상담',
        consultationType: '특정 등록권 구매상담',
        privacyConsent: true,
        privacyConsentAt: '2026-06-30 10:04',
        rightType: '특허',
        rightTitle: '마이크로바이옴 기반 질환 진단 방법',
        applicationNumber: '10-2021-0084125',
        registrationNumber: '10-2449128',
        preferredContactMethod: '전화',
        preferredContactTime: '평일 14:00~17:00'
    },
    {
        id: 'qna-604',
        system: 'ip_market',
        userType: 'buyer',
        sourceName: '남지훈',
        companyName: '오션푸드',
        contact: '010-4882-9021',
        email: 'jh.nam@oceanfood.kr',
        relatedId: 'listing-402',
        title: '친환경 포장재 특허 AI 추천상담',
        content: 'AI 추천 결과 중 체크한 특허의 식품 포장 적용 가능성과 구매 절차를 상담받고 싶습니다.',
        status: '보류',
        answer: '',
        createdAt: '2026-06-30 10:32',
        assignee: '이준호',
        audit: { handler: '이준호', handledAt: '2026-06-30 10:50', memo: '판매자 확인 대기' },
        consultationChannel: 'AI 추천상담',
        consultationKind: '구매희망상담',
        consultationType: 'AI 추천 결과 구매상담',
        privacyConsent: true,
        privacyConsentAt: '2026-06-30 10:31',
        preferredContactMethod: '이메일',
        preferredContactTime: '평일 오전',
        aiSearchSummary: '식품 접촉이 가능한 생분해성·친환경 포장 소재, 등록권 우선',
        aiRecommendedRights: [
            {
                id: 'listing-402',
                title: '해조류 유래 생분해성 포장재 조성물',
                rightType: '특허',
                applicationNumber: '10-2020-0112834',
                registrationNumber: '10-2388120',
                owner: '그린머티리얼즈 주식회사',
                matchScore: 96,
                selectedForConsultation: true
            },
            {
                id: 'listing-406',
                title: '식품용 항균 코팅 필름 및 제조방법',
                rightType: '특허',
                applicationNumber: '10-2021-0049182',
                registrationNumber: '10-2519042',
                owner: '바이오패키징랩',
                matchScore: 91,
                selectedForConsultation: true
            },
            {
                id: 'listing-409',
                title: '재활용 펄프 기반 완충 포장 구조',
                rightType: '실용신안',
                applicationNumber: '20-2022-0001845',
                registrationNumber: '20-0501842',
                owner: '에코폼',
                matchScore: 84,
                selectedForConsultation: false
            }
        ]
    }
];

export const officeConsultations: officeConsultation[] = [
    { id: 'consult-701', officeId: 'office-002', requesterName: '한유진', contact: '031-781-3302', email: 'yjhan@woorimpat.com', consultationType: '계약', content: 'A타입 계약 만료 전에 B타입 전환 조건과 할인 가능 여부를 상담하고 싶습니다.', preferredAt: '2026-07-01 10:00', status: '접수', memo: '갱신 견적서와 B타입 전환 견적 비교 필요', createdAt: '2026-06-30 09:25', assignee: '김보미' },
    { id: 'consult-702', officeId: 'office-004', requesterName: '이상혁', contact: '051-808-8821', email: 'shlee@leekwonip.co.kr', consultationType: '이용', content: '사용 인원이 꽉 차서 추가 계정 운영 방식과 계약 변경 절차를 확인하고 싶습니다.', preferredAt: '2026-06-30 15:30', status: '상담중', memo: 'C타입 전환안 안내, 대표 변리사 확인 대기', createdAt: '2026-06-29 16:18', assignee: '김보미', audit: { handler: '김보미', handledAt: '2026-06-30 10:10', memo: '상담 진행 중' } },
    { id: 'consult-703', officeId: 'office-003', requesterName: '문태식', contact: '02-742-9195', email: 'tsmoon@seumip.com', consultationType: '교육', content: '신규 직원 온보딩을 위한 관리자 교육 일정을 잡고 싶습니다.', preferredAt: '2026-07-02 14:00', status: '완료', memo: '7/2 원격 교육 확정 및 캘린더 발송 완료', createdAt: '2026-06-28 11:02', assignee: '최서윤', audit: { handler: '최서윤', handledAt: '2026-06-29 09:20', memo: '교육 일정 확정' } }
];

export function currency(value: number): string {
    return `${value.toLocaleString('ko-KR')}원`;
}

export function getOfficeName(officeId: string): string {
    return officeCustomers.find((office) => office.id === officeId)?.customerName || '-';
}

export function getListingTitle(listingId: string): string {
    return ipListings.find((listing) => listing.id === listingId)?.title || '-';
}

export function createListingFromApplication(application: ipSaleApplication): ipListing {
    const existing = ipListings.find((listing) => listing.sourceApplicationId === application.id);
    if (existing) return existing;

    const audit = makeAudit('판매신청 승인 후 매물 공개');
    const listing: ipListing = {
        id: nextId('listing'),
        title: `${application.summary} ${application.rightType}`,
        rightType: application.rightType,
        applicationNumber: application.applicationNumber,
        applicationDate: application.applicationDate,
        registrationNumber: application.registrationNumber,
        registrationDate: application.registrationDate,
        owner: application.owner,
        summary: application.summary,
        askingPrice: application.desiredPrice,
        status: '공개중',
        sellerName: application.sellerName,
        sellerContact: application.sellerContact,
        sellerEmail: application.sellerEmail,
        publicSellerLabel: application.sellerCompany === '개인' ? '개인 판매자' : '기업 판매자',
        sourceApplicationId: application.id,
        internalMemo: '판매신청 승인으로 자동 공개된 mock 매물입니다.',
        updatedBy: audit.handler,
        updatedAt: audit.handledAt,
        audit
    };
    ipListings.unshift(listing);
    return listing;
}
